import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Select, {components} from 'react-select'
import {Staff, Role} from './Proposal'
import mediumSelect2Styles from "./Components/mediumSelect2Styles";

const styles = mediumSelect2Styles();

function StaffRoleSelectionFilter(props) {
    //get all staff
    //get all roles
    var allStaffLookup = [];

    const [allStaffSorted, setStaff] = useState(window.allStaffSorted || []);
    const [allRolesSorted, setRoles] = useState(window.allRolesSorted || []);
    const [loadedStaff, setloadedStaff] = useState(0);
    const [loadedRoles, setloadedRoles] = useState(0);
    const [loadedOptions, setloadedOptions] = useState(0);
    const [loadedDefaults, setloadedDefaults] = useState(0);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState([]);
    const [selectedGroups, setSelectedGroups] = useState({});

    // const allContractorOptionsByTeam = {};
    const allStaffOptionsByTeam = [];
    const allRoleOptionsByTeam = [];
    const allSelectedOptionsByTeam = [];
    const allTeams = [];

    const handleGroupClick = function(groupName, gOptions, selectedGroups) {
        let flatOptions = [];
        Object.values(allStaffOptionsByTeam).forEach(groupValues => flatOptions.push(...groupValues))

        setValue(value => {
            let currentSelected =
                selectedGroups[groupName] ?
                    value.filter(v => (v.team != groupName && v.leaderOf != groupName)) :
                    value.concat(gOptions.filter(grpOpt => !value.includes(grpOpt)).concat(flatOptions.filter(o => o.leaderOf === groupName)));
            updateInputBoxes(currentSelected);
            return currentSelected;
        }
        );
        setSelectedGroups(groups => {
            groups[groupName] = !groups[groupName];
            return groups;
        });
    }

    const createGroup = (groupName, options, setValue, selectedGroups) => {
        return {
            label: (() => {
                return (
                    <div
                        onClick={(e) => handleGroupClick(groupName, options, selectedGroups) }
                    >
                        {groupName}
                    </div>
                );
            })(),
            options: options,
            name: groupName
        };
    };
    let updateInputBoxes = (selected) => {
        const staffListEl = document.querySelector('#task_filter_staffList');
        const roleListEl = document.querySelector('#task_filter_roleList');

        let staffList = [];
        let roleList = [];
        selected.forEach(option => {
            const [roleOrStaff, id] = option.value.split('_');

            if (roleOrStaff == 'role') {
                roleList.push(id);
            }
            if (roleOrStaff == 'staff') {
                staffList.push(option.staffCallName);
            }
        });

        staffListEl.value = staffList.toString();
        roleListEl.value = roleList.toString();
    }
    let handleOnSelectionChange = function(selected) {
        updateInputBoxes(selected);

        setValue(selected || []);

        setSelectedGroups(groups => {
            Object.keys(selectedGroups).forEach(group => {
                if (groups[group] && !selected.some(o => o.team == group)) groups[group] = false;
            });
            return groups;
        });
    }

    useEffect(() => {
        if (!window.allStaffSorted) {
            var ajax = new XMLHttpRequest();
            ajax.open("GET", '/staff/list', false);
            ajax.onload = () => {
                var response = JSON.parse(ajax.responseText);

                response.forEach(function(e) {
                    allStaffLookup[e.id] = new Staff(e.id, e.firstName, e.lastName, e.role, e.callName, e.team, e.contractor, e.active, e.leaderOf);
                    allStaffSorted.push(allStaffLookup[e.id]);
                });
                window.allStaffSorted = allStaffSorted;
                setStaff([...allStaffSorted]);
                setloadedStaff(1);
            };
            ajax.send();
        }
        if (!window.allRolesSorted) {
            var ajax = new XMLHttpRequest();
            ajax.open("GET", '/admn/roles/get_list', false);
            ajax.onload = () => {
                var response = JSON.parse(ajax.responseText);
                response.forEach(function(e) {
                    // allRoles[e.id] = new Role(e.id, e.name, 0);
                    allRolesSorted.push(new Role(e.id, e.name, 0));
                });
                setRoles([...allRolesSorted]);
                setloadedRoles(1);
                window.allRolesSorted = allRolesSorted;
            };
            ajax.send();
        }
    }, []);


    if (loadedStaff && loadedRoles) {
        let allRolesLookup = {};
        allRolesSorted.forEach(role => {
            allRolesLookup[role.id] = role;
        })


        allStaffSorted.forEach(staff => {
            // let team = staff.team ? staff.team + (staff.contractor ? ' (External Contractors)' : '')  : 'No Team';
            let team = staff.team ||  'No Team';

            if (!allStaffOptionsByTeam[team]) allStaffOptionsByTeam[team] = [];
            if (!allRoleOptionsByTeam[team]) allRoleOptionsByTeam[team] = [];
            if (!allSelectedOptionsByTeam[team]) allSelectedOptionsByTeam[team] = [];
            // if (!allContractorOptionsByTeam[team]) allContractorOptionsByTeam[team] = [];
            if (!allTeams.includes(team)) allTeams.push(team);

            let staffOption = {
                leaderOf: staff.leaderOf,
                team: team,
                staffCallName: staff.callName,
                value: 'staff' + '_' + staff.id,
                selected: value.some(v => v.value === 'staff' + '_' + staff.id),
                label: staff['firstName'] + ' ' + staff['lastName']
            };
            if (staffOption.selected) {
                allSelectedOptionsByTeam[team].push(staffOption);
            } else {
                allStaffOptionsByTeam[team].push(staffOption);
            }

            // if (staff.leaderOf) {
            //     if (!allStaffOptionsByTeam[staff.leaderOf]) allStaffOptionsByTeam[staff.leaderOf] = [];
            //     allStaffOptionsByTeam[staff.leaderOf].push({
            //         team: staff.leaderOf,
            //         staffCallName: staff.callName,
            //         value: 'staff' + '_' + staff.id,
            //         label: staff['firstName'] + ' ' + staff['lastName']
            //     })
            // }


            let role = allRolesLookup[staff.role];
            if (role) {
                let roleOption = {
                    leaderOf: staff.leaderOf,
                    roleId: role.id,
                    value: 'role' + '_' + role.id,
                    label: role['name'],
                    team: team,
                    selected: value.some(v => v.value === 'role' + '_' + role.id)
                };
                if (roleOption.selected) {
                    allSelectedOptionsByTeam[team].push(roleOption);
                } else {
                    allRoleOptionsByTeam[team].push(roleOption);
                }
            }
            delete allRolesLookup[staff.role];
        })


        if (!loadedOptions) {
            let roleSorter = (a,b) => a.label.localeCompare(b.label);
            setOptions(
                allTeams.sort(groupName => {
                    if (value.some(item => item.team === groupName)) return -1;
                    return 0;
                }).map(
                    groupName =>
                        createGroup(
                            groupName,
                    [...allSelectedOptionsByTeam[groupName].filter(item => !item.roleId),...allSelectedOptionsByTeam[groupName].filter(item => item.roleId).sort(roleSorter),...allStaffOptionsByTeam[groupName], ...allRoleOptionsByTeam[groupName].sort(roleSorter)], setValue, selectedGroups
                        )
            ));

            setloadedOptions(1);
        }

    }
    if (loadedOptions && !loadedDefaults) {

        var preSelectedRoleOptions =  props.preSelectedRoleIds.map(id => Object.values(allRoleOptionsByTeam).flat().find(v => v.roleId == id));
        var preSelectedStaffOptions =  props.preSelectedStaffCallnames.map(callName => Object.values(allStaffOptionsByTeam).flat().find(e => e.staffCallName == callName));



        setValue([...preSelectedStaffOptions, ...preSelectedRoleOptions]);
        setloadedDefaults(1);
        setloadedOptions(0)
    }



    return <Select styles={styles} options={options} isMulti={true} hideSelectedOptions={false} onChange={handleOnSelectionChange} onMenuClose={() => setloadedOptions(0)} closeMenuOnSelect={false} value={value}
                   controlShouldRenderValue={false}
                   placeholder={value.length ? value.length + ' selected' : 'Select...'}
                   // components={{ValueContainer}}

    />
}


window.renderStaffRoleUtilisationFilterWidget = function() {
    const staffListEl = document.querySelector('#task_filter_staffList');
    const roleListEl = document.querySelector('#task_filter_roleList');
    let staffValues = staffListEl && staffListEl.value ? staffListEl.value.split(",") : [];
    let roleValues = roleListEl && roleListEl.value ? roleListEl.value.split(",") : [];


    if (staffListEl  && roleListEl)
        ReactDOM.render(<StaffRoleSelectionFilter preSelectedRoleIds={roleValues} preSelectedStaffCallnames={staffValues} />, document.querySelector('#staffRoleUtilisationFilterWidget'));
}
